import styled from 'styled-components'
import {
  textStyleSizeOptions,
  textStyleWeightOptions,
  textStyleSizeStyleOptions,
  textStyleWeightStyleOptions
} from '../../fundamentals/text-styles/constants'
import colorsOptions from '../../fundamentals/colors-styles/constants'

export const InputComponent = styled.div`
  all: unset;
  display: flex;
  flex-direction: column;
  width: 100%;
`

export const InputBase = styled.input`
  all: unset;
  caret-color: ${colorsOptions.docuToolsOrange.orange};
  background-color: transparent;
  width: 100%;
  ${textStyleSizeStyleOptions[textStyleSizeOptions['TEXT-L']]}
  ${textStyleWeightStyleOptions[textStyleWeightOptions['TEXT-600']]}
  font-feature-settings: "lnum";
  min-height: 24px;

  ${({ hasValue }) =>
    hasValue &&
    `
    &[type='password'] {
      line-height: 1;
      font-size: 1.5rem;
      max-height: 24px;
    }
  `}

  &:disabled {
    color: ${colorsOptions.greys['grey-50']};
    background: transparent;
  }
`

export const LabelContainer = styled.div`
  display: flex;
  justify-content: space-between;
`

export const Label = styled.span`
  all: unset;
  display: flex;
  align-items: center;
  ${textStyleSizeStyleOptions[textStyleSizeOptions['TEXT-S']]};
  ${textStyleWeightStyleOptions[textStyleWeightOptions['TEXT-600']]};
  color: ${colorsOptions.greys['grey-50']};
  line-height: 1rem;
  &[data-disabled='true'] {
    color: ${colorsOptions.greys['grey-40']};
  }
`

export const InputContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;

  /* Default border settings */
  border-bottom: ${({ noBorderBottom }) =>
    noBorderBottom ? 'none' : '1px solid'};
  border-color: ${({ isError, readOnly }) =>
    readOnly
      ? colorsOptions.greys['grey-20']
      : isError
        ? colorsOptions.semantics.danger.error
        : colorsOptions.greys['grey-70']};

  /* Hover styles */
  &:hover {
    border-bottom: ${({ readOnly, noBorderBottom }) =>
        noBorderBottom ? 'none' : readOnly ? '1px' : '1.5px'}
      solid;
    border-color: ${({ isError, readOnly }) =>
      readOnly
        ? colorsOptions.greys['grey-20']
        : isError
          ? colorsOptions.semantics.danger.error
          : colorsOptions.greys['grey-100']};
  }

  ${InputBase} {
    color: ${({ readOnly }) =>
      readOnly
        ? colorsOptions.greys['grey-70']
        : colorsOptions.greys['grey-100']};
    pointer-events: ${({ readOnly }) => readOnly && 'none'};
  }

  &[data-disabled='true'] {
    border-color: ${colorsOptions.greys['grey-20']};
    ${InputBase} {
      color: ${colorsOptions.greys['grey-50']};
    }
  }
`

export const HintContainer = styled.div`
  display: flex;
  justify-content: start;
`

export const Hint = styled.span`
  ${textStyleSizeStyleOptions[textStyleSizeOptions['TEXT-XS']]};
  ${textStyleWeightStyleOptions[textStyleWeightOptions['TEXT-600']]};
  color: ${colorsOptions.greys['grey-70']};
`

export const HintInfo = styled(Hint)`
  color: ${colorsOptions.semantics.info.normal};
`

export const HintError = styled(Hint)`
  border-color: ${colorsOptions.semantics.danger.normal};
  color: ${colorsOptions.semantics.danger.error};
`

export const HintWarning = styled(Hint)`
  color: ${colorsOptions.semantics.warning.normal};
`

export const HintSuccess = styled(Hint)`
  color: ${colorsOptions.semantics.success.normal};
`

export const HintReadOnly = styled(Hint)`
  color: ${colorsOptions.greys['grey-50']};
`

export const HintInactive = styled(Hint)`
  color: ${colorsOptions.greys['grey-40']};
`
